import getRefreshToken from "./getRefreshToken";

// A refresh that never answers would otherwise hold every later 401 behind it, so the share has a limit.
const REFRESH_SHARE_MS = 15_000;

// Concurrent 401s share one refresh: a second refresh would fail on the rotated token and end a live session.
let refreshInFlight: ReturnType<typeof getRefreshToken> | null = null;

export const refreshOnce = (): ReturnType<typeof getRefreshToken> => {
  if (refreshInFlight) return refreshInFlight;

  const attempt = getRefreshToken();
  // Only the attempt that claimed the share may release it, so a later one is not dropped by an earlier timer.
  const release = () => {
    if (refreshInFlight === attempt) refreshInFlight = null;
  };
  const timer = setTimeout(release, REFRESH_SHARE_MS);
  const settle = () => {
    clearTimeout(timer);
    release();
  };

  void attempt.then(settle, settle);
  refreshInFlight = attempt;

  return attempt;
};
